import {AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AuthService} from 'src/app/auth/auth.service';
import {OpUser} from 'src/app/model/a2srv-operation/auth-models/opuser-model';
import {OpSession} from 'src/app/suite/usermanagement/data';
import {SessionService} from 'src/app/suite/usermanagement/services/session.service';
import {UserService} from 'src/app/suite/usermanagement/services/user.service';
import {Utility} from 'src/app/utility/utility';
import {DataSharingService} from '../data-sharing.service';
import {VodQueryParams} from '../../model/vod-query-params.model';
import {Store} from '@ngrx/store';
import {AppState} from 'src/app/app.state';
import * as QueryParamActions from 'src/app/utility/actions/queryparams.action';
import {QueryParams} from 'src/app/model/query-models/query-models';
import {ThemeService} from '../theme.service';
import {AtlasUiDomEnhancerService} from '../../utility/atlas-ui-dom-enhancer.service';
import {forkJoin} from 'rxjs';
import {CustomerService} from 'src/app/crm/customer/customer.service';
import {CustomerQueryParams} from 'src/app/model/customer-query-params.model';
import {ContentService} from 'src/app/services/cms-vod-core/contents-controller/content.service';
import {ChannelService} from 'src/app/services/cms-btv-core/channel-controller/channel.service';
import {
  buildLicenseCapacityWarnings,
  LicenseCapacityWarning,
  LicenseUsage,
  readTotalElements,
} from 'src/app/suite/atlas-license/atlas-license.model';

declare var $: any;

@Component({
  selector: 'app-master',
  templateUrl: './master.component.html',
  styleUrls: ['./master.component.scss'],
})
export class MasterComponent implements AfterViewInit, OnDestroy, OnInit {
  add: boolean = false;
  submitted: boolean = false;
  username: string;
  disabled: boolean = false;
  userRole: string;
  footerLogoBig: string = 'assets/img/transparan_logo.png';
  footerLogoDark: string = 'assets/img/saat_teknoloji_logo_dark.png';
  footerLogoSmall: string = 'assets/img/saatteknoloji_logo.png';
  footerLogoUrl: string = this.footerLogoBig;
  zabixLogoUrl: string = 'assets/img/zabbix-icon.svg';
  kibanaLogoUrl: string = 'assets/img/Kibana.svg';
  licenseDisabled: boolean = false;
  operDisabled: boolean = false;
  isOpen: boolean = true;
  newPassword: string;
  currentPassword: string;
  verifyPassword: string;
  tableLoading: boolean = true;
  sessions: OpSession[] = [];
  searchText: string;
  searchResults: any = {};
  beginDate: any;
  endDate: any;
  contentName: string;
  softwareLicenseWarnings: LicenseCapacityWarning[] = [];

  parameters = {
    userId: '',
    begindate: '',
    enddate: '',
  };

  rangeDates: any = null;
  opUser: OpUser = new OpUser();
  isStaging?: boolean = false;
  isDarkMode = false;
  canReadMessageManagement = false;
  private detachAtlasUiEnhancer: () => void;

  constructor(
    private dataSharing: DataSharingService,
    private sessionService: SessionService,
    private userService: UserService,
    private authService: AuthService,
    private customerService: CustomerService,
    private contentService: ContentService,
    private channelService: ChannelService,
    private store: Store<AppState>,
    private themeService: ThemeService,
    private elementRef: ElementRef<HTMLElement>,
    private atlasUiDomEnhancer: AtlasUiDomEnhancerService,
    public utiliy: Utility,
    public router: Router,
  ) {
    // this.footerLogoUrl = this.footerLogoBig;
    this.dataSharing.getUserData().subscribe((data) => {
      this.username = data.name;
      this.opUser = data;
    });
  }

  ngOnInit() {
    this.isDarkMode = this.themeService.initialize() === 'dark';
    //this.footerLogoUrl = this.footerLogoBig;
    //this.isStaging = environment.production ? !this.isStaging : this.isStaging;
    //
    this.updateFooterLogo();
    $('#px-nav-dropdowns-left').pxNav({
      storeState: false,
    });
    this.userRole = localStorage.getItem('user.role');
    this.username = localStorage.getItem('username');
    this.canReadMessageManagement = this.authService.hasPageAction(
      'SUITE_MESSAGE_MANAGEMENT',
      'canRead',
    );

    this.listSessionHistory();
    this.checkSoftwareLicenseCapacityWarning();
    $('#modal-searchresult').on('hidden.bs.modal', function () {
      $('#headerSearch').val('');
    });
    this.utiliy.drawMenu();
  }

  ngAfterViewInit(): void {
    this.detachAtlasUiEnhancer = this.atlasUiDomEnhancer.attach(this.elementRef.nativeElement.ownerDocument.body);
  }

  ngOnDestroy(): void {
    if (this.detachAtlasUiEnhancer) {
      this.detachAtlasUiEnhancer();
    }
  }

  toggleTheme(): void {
    this.isDarkMode = this.themeService.toggle() === 'dark';
    this.updateFooterLogo();
  }

  checkSoftwareLicenseCapacityWarning(): void {
    if (localStorage.getItem('softwareLicenseCapacityWarningShown') || !this.canViewSoftwareLicenses()) {
      return;
    }

    localStorage.setItem('softwareLicenseCapacityWarningShown', 'true');

    const customerParams = new CustomerQueryParams();
    customerParams.itemCount = 1;
    customerParams.status = ['ACTIVE'];

    const contentParams = new VodQueryParams();
    contentParams.itemCount = 1;

    forkJoin([
      this.customerService.getAllCustomers(customerParams),
      this.contentService.getAllContents(contentParams),
      this.channelService.getLicensedChannelCount(),
    ]).subscribe((responses: any[]) => {
      const usage: LicenseUsage = {
        subscriber: readTotalElements(responses[0]),
        vodTitle: readTotalElements(responses[1]),
        ltvChannel: responses[2] || 0,
      };

      this.softwareLicenseWarnings = buildLicenseCapacityWarnings(usage);

      if (this.softwareLicenseWarnings.length > 0) {
        $('#modal-software-license-capacity-warning').modal('show');
      }
    });
  }

  private canViewSoftwareLicenses(): boolean {
    if (localStorage.getItem('isAdmin') === 'true') {
      return true;
    }

    const urls: string[] = JSON.parse(localStorage.getItem('urls') || '[]');
    return urls.some((url) => '/atlas/suite/license'.includes(url));
  }

  routeToCustomer(resultId) {
    this.router.navigate(['/atlas/crm/customer/detail', resultId, 'accountinfo']);
    //
    // this.dataSharing.sendCustomerId(resultId);
  }

  // routeToVOD(resultId) {
  //   this.router.navigate(['/atlas/cms/vod/detail', resultId, 'process']);
  // }

  selectDate() {
    for (let date of this.rangeDates) {
      if (!date) return;
    }
    if (this.convertToTimestamp(this.rangeDates[0]) == this.convertToTimestamp(this.rangeDates[1])) {
      this.listSessionHistory(this.convertToTimestamp(this.rangeDates[0]), this.convertToTimestamp(this.rangeDates[1]) + 24 * 60 * 60 * 1000);
      return;
    }
    this.listSessionHistory(this.convertToTimestamp(this.rangeDates[0]), this.convertToTimestamp(this.rangeDates[1]));
  }

  convertToTimestamp(date: any) {
    return new Date(date).getTime();
  }

  listSessionHistory(beginDate?: any, endDate?: any) {
    this.parameters.userId = localStorage.getItem('userID');
    this.sessionService.listSessionHistories(this.parameters.userId, beginDate, endDate).subscribe((response) => {
      //
      if (response.code == 200) {
        this.sessions = response.data;
      } else {
      }
    });
  }

  resetTable() {
    this.rangeDates = null;
    this.listSessionHistory();
  }

  clicked() {
    if (!this.isOpen) {
      this.isOpen = true;
      this.updateFooterLogo();
    } else {
      setTimeout(() => {
        this.isOpen = false;
        this.updateFooterLogo();
      }, 250);
    }
  }

  private updateFooterLogo(): void {
    if (!this.isOpen) {
      this.footerLogoUrl = this.footerLogoSmall;
      return;
    }

    this.footerLogoUrl = this.isDarkMode ? this.footerLogoDark : this.footerLogoBig;
  }

  changePassword(form) {
    if (form.valid && this.isEqual(this.newPassword, this.verifyPassword)) {
      if (this.newPassword == this.currentPassword) {
      } else {
        this.add = true;
        this.userService.changePassword(this.currentPassword, this.newPassword, +localStorage.getItem('userID')).subscribe(
          (response) => {
            if (response.code == 200) {
              $('#modal-changepassword').modal('hide');
              // this.router.navigate(['']);
            } else {
              this.add = false;
            }
          },
          (error) => {
            this.add = false;
          },
        );
      }
    } else {
      this.submitted = true;
    }
  }

  resetForm(form) {
    this.submitted = false;
    form.resetForm();
  }

  isEqual(pass1: string, pass2: string) {
    //
    return pass1 == pass2;
  }

  signOut() {
    const sessionToken = this.authService.getToken();
    this.authService.signOut().subscribe(
      () => this.completeSignOut(sessionToken),
      () => this.completeSignOut(sessionToken),
    );
  }

  private completeSignOut(sessionToken: string): void {
    if (this.authService.clearSession(sessionToken)) {
      this.router.navigate(['/login'], {replaceUrl: true});
    }
  }

  setQueryParam(): void {
    let vodQueryParams: VodQueryParams = new VodQueryParams();
    vodQueryParams.contentName = this.contentName;

    this.store.dispatch(new QueryParamActions.SetQueryParams({queryParams: null, vodQueryParams: vodQueryParams}));
    this.router.navigate(['/atlas/cms/vod/list']);
  }
}
